/* Bulg Bundle Builder
 * Tap a color = +1 (size-agnostic). Pre-cart size x qty sheet. Adds individual
 * variant line items via the theme cart API; the live easy_bundle automatic
 * discount + native free shipping apply in cart/checkout. Tier % comes from the
 * collection metafield (data-tiers) — never hardcoded.
 */
(function () {
  var SIZE_ORDER = ['S', 'M', 'L', 'XL', 'XXL', '2XL', '3XL', 'One Size'];

  function formatMoney(cents, format) {
    format = format || '${{amount}}';
    var value = '';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    value = format.replace(/\{\{\s*amount(_no_decimals)?(_with_comma_separator|_with_space_separator)?\s*\}\}/g, function (m) {
      if (m.indexOf('no_decimals') > -1) return dollars;
      return dollars + '.' + parts[1];
    });
    return value || '$' + amount;
  }

  // GA4 funnel events (spec bulg-pack-3pack Story 10). Pushes non-PII payloads to
  // the dataLayer; consent gating is handled downstream by GTM / Consent Mode —
  // the push itself is inert until a tag fires. No PII (color names, counts, ids).
  function pushDL(event, data) {
    if (typeof window === 'undefined') return;
    window.dataLayer = window.dataLayer || [];
    var p = { event: event };
    // Stamp the A/B arm context (set by the section's arm-stamp on PDPs, or by the
    // builder itself in build mode) so every pack_* event is self-describing in GA4
    // and comparable control-vs-treatment without stitching sessions.
    var ctx = window.__bulgArm;
    if (ctx) { p.pdp_arm = ctx.pdp_arm; p.pdp_mode = ctx.pdp_mode; }
    if (data) { for (var k in data) if (Object.prototype.hasOwnProperty.call(data, k)) p[k] = data[k]; }
    window.dataLayer.push(p);
  }

  class BulgBundleBuilder extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      // Hydration flag: the section server-renders each tile as a SOLID colorway
      // hex block with inert +/- steppers (see bulg-bundle-builder.css
      // `:not(.bbb--hydrated)` rules). Flipping this class here swaps in the real
      // interactive tiles (chip photo + working steppers) the instant JS is ready,
      // so an early mobile tap before hydration is visibly not-yet-ready.
      this.classList.add('bbb--hydrated');
      var sid = this.dataset.sectionId;
      this.$ = function (p) { return document.getElementById(p + '-' + sid); };
      this.pack = this.dataset.packHandle || '';                          // pack landing analytics id
      // cents; data-free-ship is country-aware (see snippets/free-ship-min.liquid).
      // The literal is a stale-attribute guard only - keep it on the CURRENT US
      // threshold ($60, econ rework D1) so a missing attribute cannot understate it.
      this.freeShip = parseInt(this.dataset.freeShip || '6000', 10);
      this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
      try { this.tiers = JSON.parse(this.dataset.tiers || '[]'); } catch (e) { this.tiers = []; }
      this.tiers.sort(function (a, b) { return a.qty - b.qty; });

      this.cells = Array.prototype.map.call(this.querySelectorAll('.bbb__cell'), function (el) {
        var v = {};
        try { v = JSON.parse(el.dataset.variants); } catch (e) {}
        return { el: el, color: el.dataset.color, hex: el.dataset.hex, handle: el.dataset.handle,
                 cutout: el.dataset.cutout || '', title: el.dataset.title || '',
                 price: parseInt(el.dataset.price || '0', 10), variants: v };
      });
      this.counts = this.cells.map(function () { return 0; });

      // --- dual-mode PDP picker (spec bulg-dual-mode-picker) ---------------
      // pdpMode is the PAGE axis: 'single' (a colorway PDP: tap a swatch = swap
      // the shown colorway in place) | 'build' (today's pack builder: tap = +1).
      // This is DISTINCT from this.mode, which is the SIZE axis ('one'/'multi')
      // and is intentionally NOT renamed or repurposed here.
      this.pdpMode = this.dataset.pdpMode || 'build';
      // A/B arm context for pushDL. On single-mode PDPs the section's arm-stamp has
      // already set window.__bulgArm (and the treatment vs control label); don't
      // clobber it. In build mode (/products/build-your-bulg-pack, template
      // product.bulg-builder) nothing set it, so seed it from data-pdp-arm
      // (defaults to 'builder'): the always-on bundle page.
      if (!window.__bulgArm) {
        window.__bulgArm = { pdp_arm: this.dataset.pdpArm || 'builder', pdp_mode: this.pdpMode };
      }
      this.currentIndex = parseInt(this.dataset.currentIndex || '0', 10) || 0;
      if (this.currentIndex < 0 || this.currentIndex >= this.cells.length) this.currentIndex = 0;
      this.urlTemplate = this.dataset.urlTemplate || '';   // e.g. "/products/{handle}" for replaceState
      this.seedPreselect();                       // seed from server data-preselect BEFORE first render
      this.seedFromUrl();                         // organic builder: deep-link preselect from ?add=<handle> (PDP "Add to bundle")
      this.packTitle = this.dataset.packTitle || '';   // pack identity passed to the PDP return strip
      this.packUrl = this.dataset.packUrl || '';
      this.packTarget = parseInt(this.dataset.packTarget || '0', 10) || 0;
      this.hydrateFromStorage();                  // resume a same-pack in-progress selection (e.g. a colour added on a PDP)
      this.sizeQ = {};            // i -> {size:qty}
      this.touched = {};
      // sizes union, ordered
      var set = {};
      this.cells.forEach(function (c) { Object.keys(c.variants).forEach(function (s) { set[s] = 1; }); });
      this.sizes = Object.keys(set).sort(function (a, b) {
        var ia = SIZE_ORDER.indexOf(a), ib = SIZE_ORDER.indexOf(b);
        return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
      });
      this.defSize = this.sizes.indexOf('L') > -1 ? 'L' : (this.sizes.indexOf('M') > -1 ? 'M' : this.sizes[0]);
      this.inline = !!this.$('BbbSize');   // pack mode: inline size selector (no modal sheet)
      this.mode = 'one';                   // 'one' = one size for all pairs, 'multi' = per pair
      this.pairSizes = {};                 // color index -> {pairIndex: size} (per-pair sizing, multi mode)
      this._tierAdded = [];                // cell indices added by tapping a higher tier (newest last) — peeled back on a lower-tier tap
      this.sizeTouched = false;            // did the customer actually pick a size (vs. the L default)?
      this.sizeConfirmed = false;          // have they confirmed the size via the guard popup?

      this._lastTier = this.tierPct(this.totalPairs());   // don't fire tier event for the preselected default
      this.markLadderShipping();
      this.bindEvents();
      this.render();
      if (this.inline) { var selfR = this; window.addEventListener('resize', function () { selfR.syncClearance(); }); this.initHeaderCollapse(); this.initMiniHeader(); }
      pushDL('pack_builder_view', { pack_handle: this.pack, preselected: !!this._preselected, pairs: this.totalPairs() });
    }

    seedPreselect() {
      var pre = [];
      try { pre = JSON.parse(this.dataset.preselect || '[]'); } catch (e) { pre = []; }
      var self = this;
      pre.forEach(function (p) { if (p && self.counts[p.i] !== undefined) self.counts[p.i] = p.qty || 1; });
      this._preselected = pre.length > 0;
      // remember the server default trio: the hero's empty state re-shows it as
      // faded ghosts so a cleared pack never leaves a blank showcase.
      this._ghostIdx = pre.map(function (p) { return p.i; }).filter(function (i) { return self.counts[i] !== undefined; }).slice(0, 3);
    }

    /* Deep-link preselect (Liquid cannot read query params server-side, so seed client-side).
     * Two modes:
     *   1) PACK OVERRIDE (?colors= / ?preselect=, CSV of handles or colour slugs) on a no-product
     *      pack landing that opted in via data-url-preselect. This REPLACES the server default trio
     *      with exactly the URL's pack, so one page serves every advertised pack (3, 4, 5 ... colours).
     *      Fail-safe: if any token does not resolve, we keep the server default trio (never a stub).
     *   2) ORGANIC ADD (?add= / ?color=, CSV of handles) from a Bulg PDP's "Add to bundle". Adds to
     *      whatever is already selected. A server preselect wins unless this page opted into url-wins. */
    seedFromUrl() {
      var urlWins = this.dataset.urlPreselect === '1' || this.dataset.urlPreselect === 'true';
      var params;
      try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
      var byHandle = {}, byColorSlug = {}, self = this;
      this.cells.forEach(function (c, i) {
        byHandle[(c.handle || '').toLowerCase()] = i;
        byColorSlug[(c.color || '').toLowerCase().replace(/'/g, '').replace(/\s+/g, '-')] = i;
      });
      var resolve = function (t) { var i = byHandle[t]; if (i === undefined) i = byColorSlug[t]; return i; };

      // 1) Pack override: only on an opted-in (data-url-preselect) no-product landing.
      var over = urlWins ? (params.get('colors') || params.get('preselect')) : null;
      if (over) {
        var tks = over.split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
        if (tks.length) {
          var picks = [];
          tks.forEach(function (t) { var i = resolve(t); if (i !== undefined) picks.push(i); });
          if (picks.length && picks.length === tks.length) {          // every token resolved, else keep default
            if (picks.length > this.cells.length) picks = picks.slice(0, this.cells.length);  // no fixed cap; URL decides size
            this.counts = this.cells.map(function () { return 0; });   // clear the server default trio
            picks.forEach(function (i) { self.counts[i] = (self.counts[i] || 0) + 1; });
            this._preselected = true;
            return;
          }
        }
      }

      // 2) Organic add (?add / ?color): server preselect wins unless this page is url-wins.
      if (this._preselected && !urlWins) return;
      var raw = params.get('add') || params.get('color');
      if (!raw) return;
      var tokens = raw.split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
      if (!tokens.length) return;
      var applied = false;
      tokens.forEach(function (t) {
        var i = resolve(t);
        if (i !== undefined) { self.counts[i] = (self.counts[i] || 0) + 1; applied = true; }
      });
      if (applied) this._preselected = true;
    }

    /* Pack ↔ PDP bridge (pack-return.js is the PDP side).
     * persist(): mirror the live selection to sessionStorage so a colour's PDP can
     * show "back to your pack" + progress and add to the same pack. hydrate(): on
     * return, resume a same-pack selection (incl. a colour added from a PDP) so the
     * detour isn't lost. Single source of truth = sessionStorage['bulgPack']; only
     * active on pack-PRODUCT landings (this.pack set), never the organic builder. */
    PACK_KEY() { return 'bulgPack'; }
    PACK_TTL() { return 30 * 60 * 1000; }

    hydrateFromStorage() {
      if (!this.pack) return;
      var o;
      try { o = JSON.parse(sessionStorage.getItem(this.PACK_KEY()) || 'null'); } catch (e) { o = null; }
      if (!o || o.pack !== this.pack || !o.sel || !o.ts) return;
      if ((Date.now() - o.ts) > this.PACK_TTL()) return;
      var byHandle = {}, self = this;
      this.cells.forEach(function (c, i) { byHandle[c.handle] = i; });
      var fresh = this.counts.map(function () { return 0; }), applied = false;
      Object.keys(o.sel).forEach(function (h) {
        var i = byHandle[h];
        if (i !== undefined) { fresh[i] = o.sel[h]; applied = true; }
      });
      if (applied) { this.counts = fresh; this._preselected = true; }   // storage is the resumed truth
    }

    persist() {
      if (!this.pack) return;
      var sel = {}, self = this;
      this.counts.forEach(function (c, i) { if (c > 0) sel[self.cells[i].handle] = c; });
      var o = {
        pack: this.pack, url: this.packUrl, title: this.packTitle,
        target: this.packTarget || this.totalPairs(), sel: sel, tiers: this.tiers, ts: Date.now()
      };
      try { sessionStorage.setItem(this.PACK_KEY(), JSON.stringify(o)); } catch (e) {}
    }

    fireColor(ev, i) {
      var data = { pack_handle: this.pack, color: this.cells[i] ? this.cells[i].color : '', pairs: this.totalPairs() };
      pushDL(ev, data);
      // canonical analytics name (additive: keep the legacy pack_color_add firing
      // so existing GTM tags don't break, but also emit pack_color_added).
      if (ev === 'pack_color_add') pushDL('pack_color_added', data);
    }

    // Econ rework 2026-08: the Bulg ladder became AMOUNT-OFF on boxes of 3
    // ($7/$45/$71 at 3/6/9 pairs). The metafield this builder reads therefore
    // carries {qty, amount_off, pct_display} where it used to carry {qty, pct}.
    // Both shapes are resolved here so the builder keeps pricing correctly across
    // the WS2 cutover instead of silently falling back to 0% off.
    tierOffCents(tier) {
      if (!tier) return 0;
      if (typeof tier.amount_off_cents === 'number') return tier.amount_off_cents;
      if (typeof tier.amount_off === 'number') return Math.round(tier.amount_off * 100);
      return 0;
    }
    activeTier(n) {
      var hit = null;
      for (var i = 0; i < this.tiers.length; i++) if (n >= this.tiers[i].qty) hit = this.tiers[i];
      return hit;
    }
    // Percent shown in COPY. For amount-off rungs this is the ladder's own
    // pct_display, i.e. the percent rounded DOWN, never a percent we derive
    // ourselves (deriving it risks rounding up and overstating the discount).
    tierPct(n) {
      var t = this.activeTier(n);
      if (!t) return 0;
      return t.pct_display || t.pct || 0;
    }
    // Owner call 2026-08-11: savings copy leads with DOLLARS ("$45 off"), never a
    // derived percent. Falls back to the ladder's own percent on a legacy shape.
    offLabel(t) {
      var c = this.tierOffCents(t);
      if (c > 0) return this.money(c).replace(/\.00(?=\D|$)/, '') + ' off';
      var p = t && (t.pct_display || t.pct);
      return p ? p + '% off' : '';
    }
    offShort(t) {
      var c = this.tierOffCents(t);
      if (c > 0) return '−' + this.money(c).replace(/\.00(?=\D|$)/, '');
      var p = t && (t.pct_display || t.pct);
      return p ? '−' + p + '%' : '';
    }
    nextTier(n) { for (var i = 0; i < this.tiers.length; i++) if (n < this.tiers[i].qty) return this.tiers[i]; return null; }
    totalPairs() { return this.counts.reduce(function (a, b) { return a + b; }, 0); }
    rawSubtotal() { var t = 0, c = this.counts, cells = this.cells; for (var i = 0; i < c.length; i++) t += c[i] * cells[i].price; return t; }
    discounted(sub, n) {
      var off = this.tierOffCents(this.activeTier(n));
      if (off > 0) return Math.max(0, sub - off);
      return Math.round(sub * (100 - this.tierPct(n)) / 100);
    }
    money(cents) { return formatMoney(cents, this.moneyFormat); }

    markLadderShipping() {
      // unit price = first cell price (uniform across colorways); mark first rung
      // whose discounted subtotal clears the free-ship threshold. The fallback is
      // only reached with an empty grid; keep it on the current list price.
      var unit = this.cells.length ? this.cells[0].price : 2400, self = this, done = false;
      Array.prototype.forEach.call(this.querySelectorAll('.bbb__rung'), function (r) {
        var q = parseInt(r.dataset.q, 10);
        var disc = self.discounted(q * unit, q);
        if (!done && disc >= self.freeShip) {
          var s = document.createElement('span'); s.className = 'bbb__ship';
          s.innerHTML = '<svg viewBox="0 0 24 24" width="12" height="12" aria-hidden="true" style="vertical-align:-1px;fill:currentColor"><path d="M1 4h12v9H1zM13 7h4l4 4v2h-8zM5 18.5a2 2 0 110-4 2 2 0 010 4zM18 18.5a2 2 0 110-4 2 2 0 010 4z"/></svg> free';
          r.appendChild(s); done = true;
        }
      });
    }

    bindEvents() {
      var self = this;
      // hero socks → product-photo lightbox (event-delegated so it survives the
      // per-render innerHTML swap in renderHero). Click / Enter / Space all open.
      // The cut-outs are transparent images stacked in rectangular boxes, so a
      // click is resolved by PIXEL ALPHA (sockAtPoint): the topmost sock that is
      // actually opaque under the cursor — not merely the topmost box. Hover and
      // cursor use the same test, so the lift highlights the real target and the
      // pointer only turns into a hand over a real sock (incl. visible slivers of
      // socks behind the front one).
      var hero = this.$('BbbHero');
      if (hero) {
        hero.addEventListener('click', function (e) {
          var s = self.sockAtPoint(e.clientX, e.clientY);
          if (s && s.dataset.i !== undefined) self.openLightbox(+s.dataset.i, s);
        });
        hero.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
          var s = e.target.closest('.bbb__sock'); if (!s || s.dataset.i === undefined) return;
          e.preventDefault(); self.openLightbox(+s.dataset.i, s);
        });
        hero.addEventListener('pointermove', function (e) {
          self._mx = e.clientX; self._my = e.clientY;
          if (self._hovRaf) return;
          self._hovRaf = requestAnimationFrame(function () {
            self._hovRaf = 0;
            var el = self.sockAtPoint(self._mx, self._my);
            if (el !== self._hot) {
              if (self._hot) self._hot.classList.remove('is-hot');
              self._hot = el; if (el) el.classList.add('is-hot');
            }
            hero.style.cursor = el ? 'pointer' : '';
          });
        });
        hero.addEventListener('pointerleave', function () {
          if (self._hot) { self._hot.classList.remove('is-hot'); self._hot = null; }
          hero.style.cursor = '';
        });
      }
      this.$('BbbGrid').addEventListener('click', function (e) {
        if (e.target.closest('.bbb__detay')) return;        // Details → PDP link, never swaps/adds
        // SINGLE mode (colorway PDP): a swatch tap swaps the shown colorway in
        // place (image/title/price) instead of incrementing a pack. Routed
        // before the build-mode stepper logic below.
        if (self.pdpMode === 'single') {
          var scell = e.target.closest('.bbb__cell');
          if (scell && scell.dataset.i !== undefined) self.singleTap(+scell.dataset.i);
          return;
        }
        // each swatch is a split stepper: left half (−) decrements, right half (+) increments
        var dec = e.target.closest('.bbb__dec');
        var inc = e.target.closest('.bbb__inc');
        if (dec) {
          var i = +dec.dataset.i;
          if (self.counts[i] === 0) { self.counts[i]++; self.bump(i); self.fireColor('pack_color_add', i); }   // unselected tile: any tap adds
          else { self.counts[i]--; self.fireColor('pack_color_remove', i); }                                    // selected: left half removes
          self.render(); return;
        }
        if (inc) { var j = +inc.dataset.i; self.counts[j]++; self.bump(j); self.fireColor('pack_color_add', j); self.render(); return; }
        // "Tap a color = +1": a tap on the tile body or its colour caption (anywhere
        // that isn't the -/+ buttons handled above, nor the Details link) adds one
        // pair via the SAME path as +. Fixes a Clarity dead-click (users tapped the
        // colour name expecting +1 and nothing happened).
        var detay = e.target.closest('.bbb__detay');         // Details → PDP link, never adds
        if (detay) {
          var dcell = detay.closest('.bbb__cell');
          pushDL('pack_navigate', { pack_handle: self.pack, source: 'details_link',
            destination: detay.getAttribute('href') || '', color: dcell ? dcell.dataset.color : '' });
          return;
        }
        var cell = e.target.closest('.bbb__cell');
        if (cell && cell.dataset.i !== undefined) { var k = +cell.dataset.i; self.counts[k]++; self.bump(k); self.fireColor('pack_color_add', k); self.render(); }
      });
      // bar CTA: pack mode adds to cart directly (size chosen inline); organic opens the modal
      this.$('BbbCta').addEventListener('click', function () { if (self.inline) self.guardSize(function () { self.addToCart({}); }); else self.openSheet(); });

      // single-mode "Build a 3-pack with this color" CTA → seed build from the shown colorway
      var buildCta = this.$('BbbBuild');
      if (buildCta) buildCta.addEventListener('click', function () { self.enterBuild(self.currentIndex); });

      // "What is my size?" — the chart opens via an inline handler; this only adds
      // the analytics signal (how often shoppers reach for sizing help), no nav.
      this.addEventListener('click', function (e) {
        if (e.target.closest('.bbb__sizechart')) pushDL('pack_size_chart_open', { pack_handle: self.pack });
      });

      if (self.inline) {
        // ---- inline size selector (pack mode) ----
        var buy = this.$('BbbBuy');
        if (buy) buy.addEventListener('click', function () { self.guardSize(function () { self.addToCart({ checkout: true }); }); });   // express: add + go to checkout
        this.$('BbbMode').addEventListener('click', function (e) {
          var b = e.target.closest('.bbb__mbtn'); if (!b) return;
          self.sizeTouched = true;
          self.mode = b.dataset.mode; self.renderSize();
          pushDL('pack_size_mode', { pack_handle: self.pack, mode: self.mode });
        });
        this.$('BbbInPills').addEventListener('click', function (e) {
          var p = e.target.closest('.bbb__pill'); if (!p) return;
          self.sizeTouched = true;
          self.defSize = p.dataset.s; self.renderSize();
          pushDL('pack_size_selected', { pack_handle: self.pack, size: p.dataset.s, scope: 'all', pairs: self.totalPairs() });
        });
        this.$('BbbMulti').addEventListener('click', function (e) {
          var p = e.target.closest('.bbb__pill'); if (!p || p.disabled) return;
          self.sizeTouched = true;
          var i = +p.dataset.i, pr = +p.dataset.p;
          if (!self.pairSizes[i]) self.pairSizes[i] = {};
          self.pairSizes[i][pr] = p.dataset.s; self.renderSize();
          pushDL('pack_size_selected', { pack_handle: self.pack, size: p.dataset.s, scope: 'pair', pairs: self.totalPairs() });
        });
      } else {
        // ---- modal size sheet (organic builder) ----
        this.$('BbbClose').addEventListener('click', function () { self.closeSheet(); });
        this.$('BbbSheet').addEventListener('click', function (e) { if (e.target === self.$('BbbSheet')) self.closeSheet(); });
        this.$('BbbRows').addEventListener('click', function (e) {
          var b = e.target.closest('button'); if (!b) return;
          var i = +b.dataset.i, s = b.dataset.s, d = +b.dataset.d;
          self.sizeQ[i][s] = Math.max(0, (self.sizeQ[i][s] || 0) + d); self.touched[i] = true;
          self.counts[i] = self.rowTotal(i);
          if (self.counts[i] === 0) delete self.sizeQ[i];
          self.buildRows(); self.render();
        });
        this.$('BbbPills').addEventListener('click', function (e) {
          var p = e.target.closest('.bbb__pill'); if (!p) return;
          self.defSize = p.dataset.s;
          Array.prototype.forEach.call(self.$('BbbPills').children, function (x) { x.classList.toggle('is-on', x.dataset.s === self.defSize); });
          Object.keys(self.sizeQ).forEach(function (i) { i = +i; if (!self.touched[i]) { var t = self.rowTotal(i); self.sizeQ[i] = {}; self.sizeQ[i][self.defSize] = t; } });
          self.buildRows();
          pushDL('pack_size_selected', { pack_handle: self.pack, size: self.defSize, scope: 'all', pairs: self.totalPairs() });
        });
        this.$('BbbAdd').addEventListener('click', function () { self.addToCart(); });
      }
    }

    bump(i) { var el = this.cells[i].el; el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }

    /* ---- dual-mode PDP picker (spec bulg-dual-mode-picker) ----
     * SINGLE mode powers a colorway PDP: tapping a swatch swaps the shown
     * colorway IN PLACE (title/price/image) with zero network and no reload,
     * then upgrades the image to the real PDP hero once fetchProductImages
     * resolves (cached per handle). It NEVER mutates the server-rendered
     * canonical / H1 / document <title> / meta (only the section-local
     * swap-target nodes), so the feed price/title/canonical stay $16 (compliance).
     * BUILD mode is today's pack builder, unchanged. */
    renderSingle(i) {
      var cell = this.cells[i]; if (!cell) return;
      this.currentIndex = i;
      var sid = this.dataset.sectionId, self = this;
      var titleEl = document.getElementById('BbbSingleTitle-' + sid);
      var priceEl = document.getElementById('BbbSinglePrice-' + sid);
      var imgEl = document.getElementById('BbbSingleImg-' + sid);
      if (titleEl) titleEl.textContent = cell.title || cell.color || titleEl.textContent;
      if (priceEl) priceEl.textContent = this.money(cell.price);   // server unit price (cents) → $16
      if (imgEl) {
        // instant: in-memory cut-out (already cached/preloaded), no layout shift
        if (cell.cutout) imgEl.src = cell.cutout;
        imgEl.alt = cell.color || '';
      }
      // mark the active swatch (single mode shows no qty badges)
      this.cells.forEach(function (c, k) { if (c.el) c.el.classList.toggle('is-current', k === i); });
      // upgrade the showcase image to the real PDP hero when it resolves. Guard
      // against a stale resolve if the shopper tapped on to another colorway.
      if (imgEl && cell.handle) {
        this.fetchProductImages(cell.handle).then(function (imgs) {
          if (self.currentIndex !== i || self.pdpMode !== 'single') return;
          if (imgs && imgs.length) { imgEl.src = imgs[0].src; imgEl.alt = imgs[0].alt || cell.color || ''; }
        }).catch(function () {});
      }
      // reflect the colorway in the URL without a reload. replaceState (NOT push)
      // so Back still leaves the PDP cleanly. Never throws if blocked/unsupported;
      // the DOM swap above already happened.
      if (this.urlTemplate && cell.handle) {
        try {
          if (window.history && window.history.replaceState) {
            window.history.replaceState(window.history.state, '', this.urlTemplate.replace('{handle}', cell.handle));
          }
        } catch (e) {}
      }
      this.dispatchPackChanged();
    }

    singleTap(i) {
      var cell = this.cells[i]; if (!cell) return;
      this.renderSingle(i);
      pushDL('pack_single_swap', { pack_handle: this.pack, handle: cell.handle, color: cell.color });
    }

    // is any size of cell i purchasable right now?
    cellInStock(i) {
      var c = this.cells[i]; if (!c) return false;
      var v = c.variants || {};
      for (var s in v) if (Object.prototype.hasOwnProperty.call(v, s) && v[s] && v[s].available) return true;
      return false;
    }

    // pick the seed cell for build mode: the requested colorway if buyable, else
    // the first in-stock colorway, else -1 (open empty); never seed an OOS pair.
    seedableIndex(preferred) {
      if (this.cellInStock(preferred)) return preferred;
      for (var i = 0; i < this.cells.length; i++) if (this.cellInStock(i)) return i;
      return -1;
    }

    // SINGLE → BUILD: seed the pack so it never opens empty (OOS-aware), nudge the
    // shopper with a snackbar, then hand off to render() (which fires the tier
    // event + dispatches bulg:pack-changed). Intentionally does NOT auto-return to
    // single when the pack later decrements to zero (an empty build is valid).
    enterBuild(seedIndex) {
      if (typeof seedIndex !== 'number') seedIndex = this.currentIndex;
      var seed = this.seedableIndex(seedIndex);
      this.pdpMode = 'build';
      this.dataset.pdpMode = 'build';
      this.classList.add('bbb--building');
      this.counts = this.counts.map(function () { return 0; });
      if (seed >= 0) { this.counts[seed] = 1; this.currentIndex = seed; }
      var single = this.$('BbbSingle'); if (single) single.setAttribute('hidden', '');   // hand the screen to the builder
      this.snackbar('Tap colors to add to your bundle');
      pushDL('pack_mode_entered', { pack_handle: this.pack, seed_index: seed });
      this.render();   // render() dispatches bulg:pack-changed
    }

    // BUILD → SINGLE: keep currentIndex as the shown colorway.
    exitToSingle() {
      this.pdpMode = 'single';
      this.dataset.pdpMode = 'single';
      this.classList.remove('bbb--building');
      var single = this.$('BbbSingle'); if (single) single.removeAttribute('hidden');
      this.renderSingle(this.currentIndex);   // restores the single view + dispatches the event
    }

    // optimistic update for the site-wide offer bar (offer-bar.js listens for
    // bulg:pack-changed). Money is the discounted subtotal (what the customer
    // pays); freeRemaining is vs the free-ship threshold; tierPct is a quantity
    // break derived from the pair COUNT, never from money.
    dispatchPackChanged() {
      var n = this.totalPairs(), pct = this.tierPct(n), disc = this.discounted(this.rawSubtotal(), n);
      var freeRemaining = Math.max(0, this.freeShip - disc);
      try {
        this.dispatchEvent(new CustomEvent('bulg:pack-changed', {
          bubbles: true,
          detail: { pairs: n, subtotalCents: disc, tierPct: pct, freeRemainingCents: freeRemaining }
        }));
      } catch (e) {}
    }

    // 4s nudge on the existing toast surface. The toast's entrance is CSS-driven,
    // so prefers-reduced-motion is honored by the theme's global motion settings.
    snackbar(msg) { this.toast(msg, 4000); }

    render() {
      var n = this.totalPairs(), pct = this.tierPct(n), sub = this.rawSubtotal(), disc = this.discounted(sub, n), free = disc >= this.freeShip;
      var self = this;
      if (pct > (this._lastTier || 0)) pushDL('pack_tier_reached', { pack_handle: this.pack, tier_pct: pct, pairs: n });
      this._lastTier = pct;
      // Pack landing: keep the server-rendered static headline in step with the live pack size
      // (URL packs vary 3, 4, 5 ... pairs; the pack PDPs are fixed so this is a no-op there).
      if (n > 0) {
        Array.prototype.forEach.call(this.querySelectorAll('[data-static-price]'), function (box) {
          var sp = box.querySelector('.bbb__static-price'); if (sp) sp.textContent = self.money(disc);
          var sm = box.querySelector('.bbb__static-meta'); if (sm) { var mOff = self.offLabel(self.activeTier(n)); sm.textContent = n + ' pair' + (n > 1 ? 's' : '') + (mOff ? ' · ' + mOff : '') + (free ? ' · Free shipping' : ''); }
        });
      }
      this.counts.forEach(function (c, i) {
        var cell = self.cells[i].el;
        var qn = document.getElementById('BbbQn-' + self.dataset.sectionId + '-' + i);
        qn.textContent = c; if (c > 0) qn.removeAttribute('hidden'); else qn.setAttribute('hidden', '');
        cell.classList.toggle('is-active', c > 0);
      });
      Array.prototype.forEach.call(this.querySelectorAll('.bbb__rung'), function (r) {
        var q = +r.dataset.q; r.classList.toggle('is-on', n >= q);
        var nx = self.nextTier(n); r.classList.toggle('is-next', !!nx && nx.qty === q);
      });
      // bar
      var bar = this.$('BbbBar'); if (n > 0) bar.removeAttribute('hidden'); else bar.setAttribute('hidden', '');
      var thumbs = this.$('BbbThumbs');                          // absent in pack mode (dropped)
      if (thumbs) {
        var html = '', shown = 0;
        this.counts.forEach(function (c, i) {
          if (c > 0 && shown < 3) { html += '<span class="bbb__tm" style="background-image:url(' + self.cellImg(i) + ')"><b>' + c + '</b></span>'; shown++; }
        });
        var extra = this.counts.filter(function (c) { return c > 0; }).length - shown;
        if (extra > 0) html += '<span class="bbb__more">+' + extra + '</span>';
        thumbs.innerHTML = html;
      }
      var line = this.$('BbbLine'), next = this.$('BbbNext'), fill = this.$('BbbFill'), cta = this.$('BbbCta'), buy = this.$('BbbBuy'), freeEl = this.$('BbbFree');
      if (n === 0) {
        line.textContent = 'Pick your colors';
        if (freeEl) freeEl.setAttribute('hidden', '');
        if (next) { var f0 = this.tiers[0]; next.textContent = f0 ? (f0.qty + ' pairs → ' + this.offLabel(f0)) : ''; }
        if (fill) fill.style.width = '0';
      } else {
        // price on line 1; "Free shipping" on its own line below (the .bbb__free element)
        line.innerHTML = n + ' pair' + (n > 1 ? 's' : '') + ' · <b>' + this.money(disc) + '</b>' + (pct ? ' <span class="bbb__sv">save ' + this.money(sub - disc) + '</span>' : '');
        if (freeEl) {
          if (free) { freeEl.innerHTML = '<svg class="bbb__trk" viewBox="0 0 24 24" width="13" height="13" aria-hidden="true" style="fill:#2f7d57"><path d="M1 4h12v9H1zM13 7h4l4 4v2h-8zM5 18.5a2 2 0 110-4 2 2 0 010 4zM18 18.5a2 2 0 110-4 2 2 0 010 4z"/></svg>Free shipping'; freeEl.removeAttribute('hidden'); }
          else { freeEl.setAttribute('hidden', ''); }
        }
        var nx = this.nextTier(n);
        if (nx) {
          if (next) next.textContent = (nx.qty - n) + ' more → ' + this.offLabel(nx);
          if (fill) { var prevQ = 0; for (var k = 0; k < this.tiers.length; k++) if (this.tiers[k].qty < nx.qty) prevQ = this.tiers[k].qty; fill.style.width = Math.min(100, ((n - prevQ) / (nx.qty - prevQ)) * 100) + '%'; }
        } else { if (next) next.textContent = 'Best price unlocked'; if (fill) fill.style.width = '100%'; }
      }
      cta.disabled = n === 0;
      if (buy) buy.disabled = n === 0;
      this.renderTiers(n);
      this.renderHero();
      if (this.inline) { this.renderSize(); this.syncClearance(); this.updateMini(); }
      this.persist();   // keep the PDP return strip's pack context current
      this.dispatchPackChanged();   // keep the site-wide offer bar in sync (optimistic, pre-cart)
    }

    // inline size selector (pack mode): one size for all pairs + a "customize per
    // pair" toggle. No modal, no horizontal scroll — pills wrap.
    renderSize() {
      var self = this, active = [];
      this.counts.forEach(function (c, i) { if (c > 0) active.push(i); });
      var box = this.$('BbbSize'); if (!box) return;
      if (!active.length) { box.setAttribute('hidden', ''); return; }
      box.removeAttribute('hidden');
      Array.prototype.forEach.call(this.$('BbbMode').children, function (b) {
        var on = b.dataset.mode === self.mode; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on);
      });
      this.$('BbbInPills').innerHTML = this.sizes.map(function (s) {
        return '<button type="button" class="bbb__pill' + (s === self.defSize ? ' is-on' : '') + '" data-s="' + s + '">' + s + '</button>';
      }).join('');
      var one = this.$('BbbOne'), multi = this.$('BbbMulti'), note = this.$('BbbSizeNote');
      note.textContent = '';
      if (this.mode === 'multi') {
        one.setAttribute('hidden', ''); multi.removeAttribute('hidden');
        // one row per PAIR (so two pairs of the same colour can take different sizes)
        var rows = [];
        active.forEach(function (i) { for (var p = 0; p < self.counts[i]; p++) rows.push({ i: i, p: p }); });
        multi.innerHTML = rows.map(function (r) {
          var cell = self.cells[r.i];
          var cur = (self.pairSizes[r.i] && self.pairSizes[r.i][r.p]) || self.defSize;
          var pills = self.sizes.map(function (s) {
            var av = cell.variants[s] && cell.variants[s].available;
            return '<button type="button" class="bbb__pill' + (s === cur ? ' is-on' : '') + '" data-i="' + r.i + '" data-p="' + r.p + '" data-s="' + s + '"' + (av ? '' : ' disabled') + '>' + s + '</button>';
          }).join('');
          // name the colour on every row — the swatch alone can't be trusted to
          // identify it (similar shades, and in pack mode the BbbThumbs cellImg
          // path is dropped). Append "· Pair N" only when a colour has 2+ pairs.
          // Two name representations share a container; a CSS @container query
          // shows the one-line text when the name area is wide enough and flips
          // to word-per-line when it's too narrow (small screens / large zoom).
          var pairTag = self.counts[r.i] > 1 ? ' · Pair ' + (r.p + 1) : '';
          var words = cell.color.split(' ').map(function (w) { return '<span>' + w + '</span>'; }).join('');
          if (pairTag) words += '<span class="bbb__pt">' + pairTag.replace(/^\s+/, '') + '</span>';
          var chip = (cell.el.querySelector('.bbb__phimg') || {}).src || '';
          var sw = 'background-color:' + cell.hex + (chip ? ';background-image:url(' + chip + ')' : '');
          return '<div class="bbb__mrow"><span class="bbb__sw" style="' + sw + '"></span>' +
                 '<span class="bbb__nmwrap">' +
                   '<span class="bbb__nm-line">' + cell.color + pairTag + '</span>' +
                   '<span class="bbb__nm-stack">' + words + '</span>' +
                 '</span>' +
                 '<span class="bbb__pills">' + pills + '</span></div>';
        }).join('');
      } else {
        multi.setAttribute('hidden', ''); one.removeAttribute('hidden');
        var bad = active.filter(function (i) { var v = self.cells[i].variants[self.defSize]; return !(v && v.available); });
        if (bad.length) note.textContent = self.defSize + ' sold out for ' + bad.length + ' colour' + (bad.length > 1 ? 's' : '') + '. Use Per pair';
      }
    }

    // pack-mode discount progress: a slim teal milestone bar. The fill advances
    // with pair count, tier notches (%-labelled) light up as they're reached, and
    // a one-line nudge names the current discount + the next step. Built once, then
    // only the fill width / notch states / nudge text update per render.
    renderTiers(n) {
      var el = this.$('BbbTiers'); if (!el) return;
      var self = this;
      var tiers = this.tiers; if (!tiers.length) return;
      var span = Math.max(1, tiers[tiers.length - 1].qty - 1);   // bar domain: 1 → maxQ pairs
      if (!el._built) {
        // free-shipping achievement: the first pair count whose discounted subtotal
        // clears the threshold earns its own truck milestone on the same track (it
        // usually falls BETWEEN discount tiers, e.g. 3 pairs, so without this the
        // bar never shows where free shipping unlocks).
        var unit = this.cells.length ? this.cells[0].price : 2400, shipQ = 0;
        for (var sq = 1; sq <= tiers[tiers.length - 1].qty; sq++) {
          if (this.discounted(sq * unit, sq) >= this.freeShip) { shipQ = sq; break; }
        }
        var TRUCK = '<svg viewBox="0 0 24 24" width="10" height="10" aria-hidden="true" style="vertical-align:-1px;fill:currentColor"><path d="M1 4h12v9H1zM13 7h4l4 4v2h-8zM5 18.5a2 2 0 110-4 2 2 0 010 4zM18 18.5a2 2 0 110-4 2 2 0 010 4z"/></svg>';
        var shipOnTier = shipQ > 0 && tiers.some(function (t) { return t.qty === shipQ; });
        var notches = tiers.map(function (t) {
          var pos = (t.qty - 1) / span * 100;
          var ship = shipOnTier && t.qty === shipQ;
          return '<span class="bbb__pnotch' + (ship ? ' bbb__pnotch--ship' : '') + '" role="button" tabindex="0" data-q="' + t.qty +
                 '" aria-label="Set bundle to ' + t.qty + ' pairs (' + self.offLabel(t) + (ship ? ', free shipping' : '') + ')" style="left:' + pos.toFixed(1) +
                 '%"><span class="bbb__plbl">' + self.offShort(t) + (ship ? ' ' + TRUCK : '') + '</span></span>';
        }).join('');
        if (shipQ > 0 && !shipOnTier) {
          var spos = (shipQ - 1) / span * 100;
          notches += '<span class="bbb__pnotch bbb__pnotch--ship" role="button" tabindex="0" data-q="' + shipQ +
                     '" aria-label="Set bundle to ' + shipQ + ' pairs (free shipping)" style="left:' + spos.toFixed(1) +
                     '%"><span class="bbb__plbl">' + TRUCK + ' free</span></span>';
        }
        el.innerHTML = '<div class="bbb__pnudge"></div>' +
                       '<div class="bbb__ptrack"><span class="bbb__pfill"></span>' + notches + '</div>';
        el._nudge = el.querySelector('.bbb__pnudge');
        el._fill = el.querySelector('.bbb__pfill');
        el._notches = el.querySelectorAll('.bbb__pnotch');
        // tap/keyboard a tier notch → move the bundle to that tier (add a new color up / drop a sock down)
        el.addEventListener('click', function (e) {
          var notch = e.target.closest('.bbb__pnotch'); if (!notch) return;
          self.setToTier(+notch.dataset.q);
        });
        el.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
          var notch = e.target.closest('.bbb__pnotch'); if (!notch) return;
          e.preventDefault(); self.setToTier(+notch.dataset.q);
        });
        el._built = true;
      }
      var curT = this.activeTier(n), nx = this.nextTier(n);
      el._fill.style.width = Math.min(100, Math.max(0, (n - 1) / span * 100)) + '%';
      Array.prototype.forEach.call(el._notches, function (c) { c.classList.toggle('is-on', n >= +c.dataset.q); });
      var txt;
      if (nx) {
        var gap = nx.qty - n, more = gap + ' more pair' + (gap > 1 ? 's' : '');
        txt = curT ? '<b>' + this.offLabel(curT) + '</b> · ' + more + ' &rarr; ' + this.offShort(nx).replace('−', '')
                   : more + ' &rarr; ' + this.offLabel(nx);
      } else {
        txt = '<b>' + this.offLabel(curT) + '</b> · best price';
      }
      el._nudge.innerHTML = txt;
    }

    // Tap a discount-tier notch → move the bundle to that tier's pair count.
    // UP adds a RANDOM not-yet-picked color (one pair each) for variety — it never
    // just piles pairs onto colors already chosen (unless every color is taken).
    // DOWN removes socks until the count matches the tier, peeling off the most
    // recently tier-added colors first so an up-tap is cleanly reversible.
    setToTier(targetQty) {
      var n = this.totalPairs();
      if (!targetQty || n === targetQty) return;
      var self = this, touched = -1, i, j;
      if (targetQty > n) {
        for (var up = 0; up < targetQty - n; up++) {
          var avail = [];
          for (i = 0; i < self.counts.length; i++) { if (self.counts[i] === 0) avail.push(i); }   // unpicked colors
          var pick = -1;
          if (avail.length) { pick = avail[Math.floor(Math.random() * avail.length)]; }            // pick a RANDOM new color
          else { for (j = 0; j < self.counts.length; j++) { if (self.counts[j] > 0) { pick = j; break; } } }  // all picked: bump first active
          if (pick < 0) break;
          self.counts[pick]++; self._tierAdded.push(pick); touched = pick;
        }
      } else {
        for (var down = 0; down < n - targetQty; down++) {
          var idx = -1;
          while (self._tierAdded.length) { var c = self._tierAdded.pop(); if (self.counts[c] > 0) { idx = c; break; } }  // newest tier-added, still selected
          if (idx < 0) { var best = -1, bc = 0; self.counts.forEach(function (cc, k) { if (cc > bc) { bc = cc; best = k; } }); idx = best; }  // else: drop a pair off the highest-count color
          if (idx < 0) break;
          self.counts[idx]--; touched = idx;
        }
      }
      if (touched >= 0) this.bump(touched);
      pushDL('pack_tier_tap', { pack_handle: this.pack, target_qty: targetQty, pairs: this.totalPairs() });
      this.render();
    }

    // Size guard: if the customer never picked a size (still riding the L default),
    // intercept Add-to-cart / Buy-now with a confirm popup before proceeding.
    guardSize(proceed) {
      if (!this.inline || this.sizeTouched || this.sizeConfirmed || this.totalPairs() === 0) { proceed(); return; }
      this.sizeConfirmPopup(proceed);
    }

    sizeConfirmPopup(proceed) {
      var self = this, sizes = this.sizes || [];
      var bg = document.createElement('div');
      bg.className = 'bbb__confirmbg';
      var pills = sizes.map(function (s) {
        return '<button type="button" class="bbb__cpill' + (s === self.defSize ? ' is-on' : '') + '" data-s="' + s + '">' + s + '</button>';
      }).join('');
      bg.innerHTML =
        '<div class="bbb__confirm" role="dialog" aria-modal="true" aria-label="Confirm your size">' +
          '<button type="button" class="bbb__cx" aria-label="Close">&times;</button>' +
          '<h3 class="bbb__ctitle">Confirm your size</h3>' +
          '<p class="bbb__ctext">All pairs are set to <b class="bbb__csize">' + self.defSize + '</b>. Pick your size or continue.</p>' +
          '<div class="bbb__cpills">' + pills + '</div>' +
          '<button type="button" class="bbb__ccta">Continue with <span class="bbb__csize2">' + self.defSize + '</span></button>' +
        '</div>';
      function close() { bg.remove(); document.removeEventListener('keydown', onKey); }
      function onKey(e) { if (e.key === 'Escape') close(); }
      bg.addEventListener('click', function (e) {
        if (e.target === bg || e.target.closest('.bbb__cx')) { close(); return; }
        var pill = e.target.closest('.bbb__cpill');
        if (pill) { self.sizeTouched = true; self.sizeConfirmed = true; self.defSize = pill.dataset.s; self.renderSize(); close(); proceed(); return; }
        if (e.target.closest('.bbb__ccta')) { self.sizeConfirmed = true; close(); proceed(); }
      });
      document.addEventListener('keydown', onKey);
      document.body.appendChild(bg);
    }

    // keep the page's bottom clearance matched to the (variable-height) fixed bar so
    // the footer always clears it — robust to viewport width + OS text scaling.
    syncClearance() {
      var bar = this.$('BbbBar');
      if (!bar) return;
      // only the FIXED mobile bar needs body clearance; on desktop (≥990px) the bar
      // is sticky/in-flow, so don't reserve bottom space.
      if (bar.hasAttribute('hidden') || getComputedStyle(bar).position !== 'fixed') { document.body.style.removeProperty('padding-bottom'); return; }
      document.body.style.setProperty('padding-bottom', Math.ceil(bar.getBoundingClientRect().height + 22) + 'px', 'important');
    }

    // Pack page only: make the theme's sticky header STATIC so it scrolls away with
    // the page and does NOT re-appear on scroll-up (frees vertical space).
    initHeaderCollapse() {
      var hdr = document.querySelector('header.header') || document.querySelector('.section-header') || document.querySelector('header');
      var wrap = hdr ? (hdr.closest('[id^="shopify-section"]') || hdr) : null;
      if (!wrap) return;
      wrap.style.setProperty('position', 'static', 'important');
    }

    // ── MOBILE mini-header (pack mode, display-only) ─────────────────────────
    // A slim bar pinned to the top once the builder scrolls out of view: a
    // shrunk mirror of the pack hero image + the swatch grid (with live active
    // state), so the pack stays visible. Tap / Enter smooth-scrolls back to the
    // builder. Overlay (position:fixed) so it never reserves flow space; shown
    // only on mobile (CSS media query) and only in pack mode (this.inline). It
    // MIRRORS the live selection via updateMini() on every render — it never
    // mutates the real builder DOM/state, and the mini swatches are not tappable.
    initMiniHeader() {
      if (this._mini || !this.inline) return;
      var hero = this.$('BbbHero'); if (!hero) return;
      var self = this, sid = this.dataset.sectionId;
      var mini = document.createElement('div');
      mini.className = 'bbb__mini';
      mini.id = 'BbbMini-' + sid;
      mini.setAttribute('role', 'button');
      mini.setAttribute('tabindex', '-1');            // becomes 0 only while shown
      mini.setAttribute('aria-hidden', 'true');
      mini.setAttribute('aria-label', 'Back to pack builder');
      mini.innerHTML =
        '<div class="bbb__mini-hero"><div class="bbb__mini-stage"></div></div>' +
        '<div class="bbb__mini-grid">' + this.buildMiniGrid() + '</div>';
      document.body.appendChild(mini);
      this._mini = mini;
      this._miniCells = mini.querySelectorAll('.bbb__mini-cell');
      var go = function () { self.scrollToBuilder(); };
      mini.addEventListener('click', go);
      mini.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); go(); }
      });
      // Show the mini once the hero has scrolled up out of the viewport; hide it
      // again at the top. IntersectionObserver (not a scroll listener) to stay cheap.
      if ('IntersectionObserver' in window) {
        this._miniIO = new IntersectionObserver(function (entries) {
          var e = entries[entries.length - 1];
          self.toggleMini(!e.isIntersecting && e.boundingClientRect.top <= 0);
        }, { threshold: 0 });
        this._miniIO.observe(hero);
      }
      this.updateMini();   // seed initial content
    }

    // Display-only mini swatches mirroring the real grid cells (hex + chip photo).
    buildMiniGrid() {
      return this.cells.map(function (c, i) {
        var chip = (c.el.querySelector('.bbb__phimg') || {}).src || '';
        var bg = 'background-color:' + (c.hex || '#cccccc') + (chip ? ';background-image:url(' + chip + ')' : '');
        return '<span class="bbb__mini-cell" data-i="' + i + '" style="' + bg + '"><b class="bbb__mini-qn" hidden></b></span>';
      }).join('');
    }

    // Mirror the live pack into the mini header: clone the hero stage markup
    // (scaled down by CSS) and reflect each cell's active state + qty. Never
    // mutates the real builder DOM/state; no-op until the mini exists (pack mode).
    updateMini() {
      var mini = this._mini; if (!mini) return;
      var hero = this.$('BbbHero');
      var heroStage = hero && hero.querySelector('.bbb__stage');
      var miniStage = mini.querySelector('.bbb__mini-stage');
      if (heroStage && miniStage) {
        miniStage.innerHTML = heroStage.innerHTML;   // same-src imgs reuse cache, no refetch
        // display-only: neutralize the cloned socks' interactivity
        Array.prototype.forEach.call(miniStage.querySelectorAll('[tabindex],[role]'), function (el) {
          el.setAttribute('tabindex', '-1'); el.removeAttribute('role');
        });
        mini.classList.toggle('is-empty', hero.classList.contains('is-empty'));
      }
      if (this._miniCells) {
        var cells = this._miniCells;
        this.counts.forEach(function (c, i) {
          var mc = cells[i]; if (!mc) return;
          mc.classList.toggle('is-active', c > 0);
          var qn = mc.querySelector('.bbb__mini-qn');
          if (qn) {
            if (c > 1) { qn.textContent = c; qn.removeAttribute('hidden'); }
            else { qn.textContent = ''; qn.setAttribute('hidden', ''); }
          }
        });
      }
    }

    // Slide the mini in/out; keep it out of the tab order + SR tree when hidden.
    toggleMini(show) {
      var mini = this._mini; if (!mini) return;
      show = !!show;
      if (mini.classList.contains('is-shown') === show) return;
      mini.classList.toggle('is-shown', show);
      mini.setAttribute('aria-hidden', show ? 'false' : 'true');
      mini.setAttribute('tabindex', show ? '0' : '-1');
    }

    // Smooth-scroll back to the builder (respects prefers-reduced-motion).
    scrollToBuilder() {
      var hero = this.$('BbbHero') || this.querySelector('.bbb__hero') || this.closest('.bbb') || this;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
      var top = Math.max(0, hero.getBoundingClientRect().top + window.pageYOffset - 8);
      try { window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' }); }
      catch (e) { window.scrollTo(0, top); }
    }

    // Dynamic "desk" hero: the active colors as overlapping sock cut-outs on the
    // studio-grey surface (NO shadow), ×N badge when a color's qty > 1. Geometry
    // mirrors the server render in bulg-bundle-builder.liquid so JS-on == JS-off.
    // No-ops when the section has no hero (organic builder) — element is absent.
    renderHero() {
      var hero = this.$('BbbHero');
      if (!hero) return;
      var self = this, active = [];
      this.counts.forEach(function (c, i) { if (c > 0) active.push({ i: i, qty: c }); });
      // Empty state: never leave a blank desk. Re-show the default trio as faded,
      // non-interactive ghosts plus a centred prompt, so the showcase still reads
      // as "socks go here" while making clear nothing is selected.
      var ghost = false;
      if (!active.length && this._ghostIdx && this._ghostIdx.length) {
        ghost = true;
        active = this._ghostIdx.map(function (i) { return { i: i, qty: 1 }; });
      }
      // ROT is keyed to each colour's STABLE swatch index (a.i % 6), not loop
      // position, so adding/removing a colour never re-tilts an already-placed
      // sock. Liquid hero_html mirrors this (rotate by parts[2] % 6).
      var m = active.length, ROT = [0, 0, 0, 0, 0, 0], html = '';
      // Hero layout ported verbatim from the design tool bulg-hero-playground.html
      // (AUTO mode). One unified model for every colour count, so the hero stays
      // consistent as the pack grows instead of cramming everything into one
      // shrinking row:
      //   rowsFor(m): m<=T1 -> 1 row, m<=T2 -> 2 rows, else 3 rows.
      //   distribute(): split evenly, remainder to the front (lower) rows.
      //   AUTO formula (per the playground's auto toggle): horizontal overlap and
      //     the height cap follow the row count; vertical overlap is fixed.
      //   Tile width is derived from the horizontal overlap; height from the sock
      //     aspect ratio (KNOM = sock w/h * box h/w), clamped to the height cap.
      // Tunables — change these to match a fresh playground export:
      var T1 = 9;        // 1 -> 2 row threshold (>T1 colours wraps to 2 rows)
      var T2 = 18;       // 2 -> 3 row threshold
      var VOV = 0.37;    // vertical overlap between rows (AUTO)
      var EDGE = 1;      // % margin on each side
      var KNOM = 0.8127 * 0.6;   // sock aspect (w/h, full cut-out) * hero box h/w (5:3)
      var R = m <= T1 ? 1 : (m <= T2 ? 2 : 3);
      var base = Math.floor(m / R), rem = m % R, counts = [];
      for (var r = 0; r < R; r++) counts.push(base + (r < rem ? 1 : 0));   // remainder to front rows
      var maxn = Math.max.apply(null, counts), s = Math.ceil(m / R);
      var OV = Math.min(80, 25 + 5 * s) / 100;          // AUTO horizontal overlap
      var Hmax = (R === 1 ? 90 : 61);                   // AUTO max tile height %
      var Wc = (100 - 2 * EDGE) / (1 + (maxn - 1) * (1 - OV));   // tile width %
      var sh = Wc / KNOM;                               // -> tile height %
      if (sh > Hmax) { sh = Hmax; Wc = sh * KNOM; }     // clamp; narrow to keep aspect
      var stride = Wc * (1 - OV);
      var stackH = sh + (R - 1) * sh * (1 - VOV);
      var bottom0 = (100 - stackH) / 2;                 // align: centre the stack
      // Lay slots out back row -> front row, each left -> right (the playground's
      // fill order); active[] is in ascending colour index, so active[k] -> slot k.
      var slots = [];
      for (var j = R - 1; j >= 0; j--) {
        var n = counts[j], gw = Wc + (n - 1) * stride, cstart = 50 - gw / 2 + Wc / 2;
        var rb = bottom0 + j * sh * (1 - VOV), zrow = (R - 1) - j;   // front row (j=0) sits on top
        for (var c = 0; c < n; c++) slots.push({ cx: cstart + c * stride, bottom: rb, z: zrow * 100 + c });
      }
      // tap affordance shown on touch devices (no hover) so it's obvious each sock
      // is individually clickable — a small magnifier on each sock's visible toe.
      var MAG = '<i class="bbb__sock-tap" aria-hidden="true"><svg viewBox="0 0 24 24" width="13" height="13"><circle cx="11" cy="11" r="6" fill="none" stroke="currentColor" stroke-width="2.2"/><path d="M15.5 15.5L20 20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg></i>';
      active.forEach(function (a, k) {
        var sl = slots[k] || { cx: 50, bottom: bottom0, z: k + 1 };
        var cell = self.cells[a.i] || {};
        html += ghost
          ? '<span class="bbb__sock bbb__sock--ghost" aria-hidden="true" style="left:' + sl.cx.toFixed(2) + '%;bottom:' + sl.bottom.toFixed(2) + '%;height:' + sh.toFixed(2) + '%;z-index:' + sl.z +
            ';transform:translateX(-50%) rotate(' + ROT[a.i % 6] + 'deg)">' +
            '<img src="' + (cell.cutout || '') + '" alt="" decoding="async">' +
            '</span>'
          : '<span class="bbb__sock" data-i="' + a.i + '" role="button" tabindex="0" aria-label="View ' + (cell.color || '').replace(/"/g, '&quot;') + ' photos" style="left:' + sl.cx.toFixed(2) + '%;bottom:' + sl.bottom.toFixed(2) + '%;height:' + sh.toFixed(2) + '%;z-index:' + sl.z +
            ';transform:translateX(-50%) rotate(' + ROT[a.i % 6] + 'deg)">' +
            '<img src="' + (cell.cutout || '') + '" alt="' + (cell.color || '') + '" decoding="async">' +
            (a.qty > 1 ? '<b class="bbb__sock-badge">&times;' + a.qty + '</b>' : '') + MAG +
            '</span>';
      });
      if (ghost) html += '<span class="bbb__ghost-hint">Tap a color to start your pack</span>';
      hero.classList.toggle('is-empty', ghost);
      (hero.querySelector('.bbb__stage') || hero).innerHTML = html;
      hero.setAttribute('aria-label', !ghost && active.length
        ? 'Your pack: ' + active.map(function (a) { return (self.cells[a.i] || {}).color + (a.qty > 1 ? ' ×' + a.qty : ''); }).join(', ')
        : 'Build your pack');
    }

    /* ---- alpha hit-testing for the overlapping hero socks ----
     * The cut-outs are transparent images stacked in rectangular boxes; a click
     * over a transparent corner of the front sock should reach the visible sock
     * behind it. We decode each cut-out once into a downscaled alpha grid (cached
     * by src), then on a pointer event walk the socks top→bottom and return the
     * first whose pixel under the cursor is opaque. Falls back to box hit-testing
     * if the alpha map isn't ready yet or the image can't be read (CORS taint). */
    ensureAlpha(src) {
      this._alpha = this._alpha || {};
      if (!src || this._alpha[src]) return;
      this._alpha[src] = 'pending';
      var self = this, img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        try {
          var scale = Math.min(1, 180 / (img.naturalWidth || 180));
          var w = Math.max(1, Math.round((img.naturalWidth || 180) * scale));
          var h = Math.max(1, Math.round((img.naturalHeight || 220) * scale));
          var c = document.createElement('canvas'); c.width = w; c.height = h;
          var ctx = c.getContext('2d'); ctx.drawImage(img, 0, 0, w, h);
          var d = ctx.getImageData(0, 0, w, h).data, a = new Uint8Array(w * h);
          for (var i = 0, j = 3; i < a.length; i++, j += 4) a[i] = d[j];
          self._alpha[src] = { w: w, h: h, a: a };
        } catch (e) { self._alpha[src] = 'failed'; }   // tainted canvas → box fallback
      };
      img.onerror = function () { self._alpha[src] = 'failed'; };
      img.src = src;
    }

    alphaAt(src, nx, ny) {
      var m = this._alpha && this._alpha[src];
      if (!m || m === 'pending' || m === 'failed') return -1;   // unknown → caller falls back
      var px = Math.min(m.w - 1, Math.max(0, Math.floor(nx * m.w)));
      var py = Math.min(m.h - 1, Math.max(0, Math.floor(ny * m.h)));
      return m.a[py * m.w + px];
    }

    sockAtPoint(x, y) {
      var hero = this.$('BbbHero'); if (!hero) return null;
      var socks = hero.querySelectorAll('.bbb__sock');
      // DOM order is ascending z-index, so iterate last→first = top→bottom.
      for (var k = socks.length - 1; k >= 0; k--) {
        var el = socks[k], r = el.getBoundingClientRect();
        if (x < r.left || x > r.right || y < r.top || y > r.bottom) continue;
        var src = (el.querySelector('img') || {}).src || '';
        this.ensureAlpha(src);
        var av = this.alphaAt(src, (x - r.left) / r.width, (y - r.top) / r.height);
        if (av < 0) return el;    // alpha map not ready / unreadable → box hit (graceful fallback)
        if (av > 20) return el;   // opaque pixel → definitive hit
        // transparent pixel → fall through to the sock beneath
      }
      return null;   // outside every box, or only over transparent pixels
    }

    cellImg(i) {
      var ph = this.cells[i].el.querySelector('.bbb__ph');
      var bg = getComputedStyle(ph).backgroundImage;
      return bg.slice(4, -1).replace(/["']/g, '');
    }

    /* ---- size sheet ---- */
    rowTotal(i) { var q = this.sizeQ[i] || {}, t = 0, self = this; this.sizes.forEach(function (s) { t += q[s] || 0; }); return t; }
    openSheet() {
      var self = this;
      this.counts.forEach(function (c, i) {
        if (c > 0) { if (!self.sizeQ[i] || !self.touched[i]) { self.sizeQ[i] = {}; self.sizeQ[i][self.defSize] = c; } }
        else delete self.sizeQ[i];
      });
      // default pills
      this.$('BbbPills').innerHTML = this.sizes.map(function (s) {
        return '<button type="button" class="bbb__pill' + (s === self.defSize ? ' is-on' : '') + '" data-s="' + s + '">' + s + '</button>';
      }).join('');
      this.buildRows();
      this.$('BbbSheet').removeAttribute('hidden');
      pushDL('pack_size_sheet_open', { pack_handle: this.pack, pairs: this.totalPairs() });
    }
    closeSheet() { this.$('BbbSheet').setAttribute('hidden', ''); }
    buildRows() {
      var self = this, html = '';
      Object.keys(this.sizeQ).forEach(function (i) {
        i = +i; var cell = self.cells[i];
        html += '<div class="bbb__srow"><span class="bbb__sw" style="background-image:url(' + self.cellImg(i) + ')"></span><span class="bbb__nm">' + cell.color + '</span><span class="bbb__szs">';
        self.sizes.forEach(function (s) {
          var avail = cell.variants[s] && cell.variants[s].available;
          var has = !!(cell.variants[s]);
          var v = self.sizeQ[i][s] || 0;
          html += '<span class="bbb__szg"><span class="bbb__sl">' + s + '</span><span class="bbb__stp' + (v ? '' : ' is-zero') + '">' +
            '<button data-i="' + i + '" data-s="' + s + '" data-d="-1" aria-label="decrease ' + s + '"' + (v ? '' : ' disabled') + '>&minus;</button>' +
            '<span class="bbb__v">' + v + '</span>' +
            '<button data-i="' + i + '" data-s="' + s + '" data-d="1" aria-label="increase ' + s + '"' + (has && avail ? '' : ' disabled') + '>&plus;</button>' +
            '</span></span>';
        });
        html += '</span></div>';
      });
      this.$('BbbRows').innerHTML = html || '<p style="opacity:.6;padding:10px 0">Pick a color first.</p>';
      this.recap();
    }
    recap() {
      var self = this, n = 0; Object.keys(this.sizeQ).forEach(function (i) { n += self.rowTotal(+i); });
      var sub = 0; Object.keys(this.sizeQ).forEach(function (i) { i = +i; sub += self.rowTotal(i) * self.cells[i].price; });
      var pct = this.tierPct(n), disc = this.discounted(sub, n), free = disc >= this.freeShip, sv = sub - disc;
      var recap = this.$('BbbRecap'), add = this.$('BbbAdd');
      // Upsell hint derived from the metafield-driven ladder (this.tiers) and the
      // free-ship threshold, never hardcoded (same nextTier pattern as render()).
      // this.freeShip is already country-aware (data-free-ship via free-ship-min),
      // so the money amount localizes; keep the wording country-neutral.
      var nx = this.nextTier(n), hintBits = [];
      if (n > 0) {
        if (nx) hintBits.push((nx.qty - n) + ' more → ' + this.offLabel(nx));
        if (!free && this.freeShip > 0) hintBits.push('free shipping at ' + this.money(this.freeShip));
      }
      var hint = hintBits.length ? '<br><small style="color:#b3402f">' + hintBits.join(' · ') + '</small>' : '';
      recap.innerHTML = n ? ('<span class="bbb__big">' + n + ' pairs · ' + this.money(disc) + '</span>' +
        (pct ? ' <span class="bbb__sv">' + this.offLabel(this.activeTier(n)) + (free ? ' · free shipping' : '') + '</span>' : '') +
        hint) : 'Nothing selected';
      add.disabled = n === 0;
      add.textContent = n ? ('Add to cart · ' + n + ' pairs · ' + this.money(disc)) : 'Add to cart';
    }

    addToCart(opts) {
      opts = opts || {};
      var self = this, items = [], unavailable = [];
      if (this.inline) {
        // expand each colour into its pairs; in 'multi' each pair carries its own
        // size (pairSizes[i][p]); collapse identical variants into one line item.
        var byId = {};
        this.counts.forEach(function (q, i) {
          if (q <= 0) return;
          for (var p = 0; p < q; p++) {
            var size = self.mode === 'multi' ? ((self.pairSizes[i] && self.pairSizes[i][p]) || self.defSize) : self.defSize;
            var v = self.cells[i].variants[size];
            if (v && v.available) byId[v.id] = (byId[v.id] || 0) + 1;
            else if (unavailable.indexOf(self.cells[i].color) < 0) unavailable.push(self.cells[i].color);
          }
        });
        Object.keys(byId).forEach(function (id) { items.push({ id: +id, quantity: byId[id] }); });
        if (unavailable.length) self.toast(unavailable.join(', ') + ' unavailable in that size');
      } else {
        Object.keys(this.sizeQ).forEach(function (i) {
          i = +i; var cell = self.cells[i];
          self.sizes.forEach(function (s) {
            var q = self.sizeQ[i][s] || 0;
            if (q > 0 && cell.variants[s]) items.push({ id: cell.variants[s].id, quantity: q });
          });
        });
      }
      if (!items.length) return;
      var ctaBtn = this.$('BbbCta'), buyBtn = this.$('BbbBuy');
      var btn = this.inline ? ctaBtn : this.$('BbbAdd');
      if (ctaBtn) ctaBtn.disabled = true; if (buyBtn) buyBtn.disabled = true; if (!this.inline && btn) btn.disabled = true;
      var reenable = function () { if (ctaBtn) ctaBtn.disabled = false; if (buyBtn) buyBtn.disabled = false; if (!self.inline && btn) btn.disabled = false; };
      fetch(window.FoxTheme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (res && res.status) { self.toast("Couldn't add: " + (res.description || res.message || 'error')); reenable(); return; }
        var n = self.totalPairs();
        var addPayload = { pack_handle: self.pack, pairs: n, tier_pct: self.tierPct(n),
          value: self.discounted(self.rawSubtotal(), n) / 100, checkout: !!opts.checkout,
          item_ids: items.map(function (it) { return it.id; }) };
        pushDL('pack_add_to_cart', addPayload);
        // canonical analytics name (additive: keep the legacy pack_add_to_cart too)
        pushDL('pack_added_to_cart', addPayload);
        if (opts.checkout) { window.location.href = self.checkoutUrl(); return; }   // express: straight to checkout
        if (!self.inline) self.closeSheet();
        self.toast('Added to cart · ' + n + ' pair' + (n > 1 ? 's' : ''));
        // keep the selection on screen after adding — the cart drawer (opened below)
        // shows what's in the cart; blanking the builder looked broken ("no socks").
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
      }).catch(function () { self.toast('Connection error'); reenable(); });
    }

    checkoutUrl() {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      if (root.charAt(root.length - 1) !== '/') root += '/';
      return root + 'checkout';
    }

    toast(msg, dur) {
      var t = this.$('BbbToast'); t.textContent = msg; t.removeAttribute('hidden');
      clearTimeout(this._tt); var self = this; this._tt = setTimeout(function () { t.setAttribute('hidden', ''); }, dur || 3200);
    }

    /* ---- product-photo lightbox (tap a hero sock) ----
     * A dismissable overlay with the tapped colour's product photos in a
     * horizontally swipeable carousel (native CSS scroll-snap = real touch swipe,
     * + prev/next buttons, dots, and arrow keys). Photos are pulled from the
     * Storefront product .js endpoint and cached per handle. Built lazily on first
     * open and appended to <body> so the hero's overflow:hidden never clips it. */
    shopRoot() {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      if (root.charAt(root.length - 1) !== '/') root += '/';
      return root;
    }

    sizedUrl(src, w) {
      if (!src) return src;
      // request a crisp width from the Shopify CDN (drop any existing query first)
      return src.split('?')[0] + '?width=' + w;
    }

    fetchProductImages(handle) {
      this._imgCache = this._imgCache || {};
      if (this._imgCache[handle]) return Promise.resolve(this._imgCache[handle]);
      var self = this;
      return fetch(this.shopRoot() + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var out = [], media = (p && p.media) || [];
          media.forEach(function (m) {
            if (m && m.media_type === 'image' && m.src) {
              var ar = m.aspect_ratio || (m.width && m.height ? m.width / m.height : null);
              out.push({ src: self.sizedUrl(m.src, 1200), alt: m.alt || (p.title || ''), ar: ar });
            }
          });
          if (!out.length && p && p.images) p.images.forEach(function (src) { out.push({ src: self.sizedUrl(src, 1200), alt: p.title || '', ar: null }); });
          self._imgCache[handle] = out;
          return out;
        });
    }

    ensureLightbox() {
      if (this._lb) return this._lb;
      var self = this;
      var el = document.createElement('div');
      el.className = 'bbb__lb';
      el.setAttribute('hidden', '');
      var X_ICON = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
      var CHEV = function (d) { return '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"><path d="' + d + '" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>'; };
      el.innerHTML =
        '<div class="bbb__lb-backdrop" data-lb-close></div>' +
        '<div class="bbb__lb-dialog" role="dialog" aria-modal="true" aria-label="Product photos" tabindex="-1">' +
          '<button type="button" class="bbb__lb-x" data-lb-close aria-label="Close">' + X_ICON + '</button>' +
          '<div class="bbb__lb-stage">' +
            '<button type="button" class="bbb__lb-nav bbb__lb-prev" aria-label="Previous photo">' + CHEV('M15 4l-8 8 8 8') + '</button>' +
            '<div class="bbb__lb-track" tabindex="0"></div>' +
            '<button type="button" class="bbb__lb-nav bbb__lb-next" aria-label="Next photo">' + CHEV('M9 4l8 8-8 8') + '</button>' +
          '</div>' +
          '<div class="bbb__lb-foot">' +
            '<span class="bbb__lb-cap"></span>' +
            '<span class="bbb__lb-dots"></span>' +
            '<a class="bbb__lb-link" href="#">View product' +
              '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" focusable="false"><path d="M5 12h13M13 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
            '</a>' +
          '</div>' +
        '</div>';
      document.body.appendChild(el);
      var lb = {
        el: el, track: el.querySelector('.bbb__lb-track'), dots: el.querySelector('.bbb__lb-dots'),
        cap: el.querySelector('.bbb__lb-cap'), link: el.querySelector('.bbb__lb-link'),
        prev: el.querySelector('.bbb__lb-prev'), next: el.querySelector('.bbb__lb-next'),
        dialog: el.querySelector('.bbb__lb-dialog')
      };
      this._lb = lb;
      // dismiss on any click outside the dialog (backdrop / margins) or on a
      // close-marked element (the × button, which lives inside the dialog).
      el.addEventListener('click', function (e) {
        if (e.target.closest('[data-lb-close]') || !e.target.closest('.bbb__lb-dialog')) self.closeLightbox();
      });
      lb.prev.addEventListener('click', function () { self.lbStep(-1); });
      lb.next.addEventListener('click', function () { self.lbStep(1); });
      lb.dots.addEventListener('click', function (e) { var d = e.target.closest('button'); if (d) self.lbGoTo(+d.dataset.k); });
      window.addEventListener('resize', function () { if (!el.hasAttribute('hidden')) self.lbSize(); });
      document.addEventListener('keydown', function (e) {
        if (el.hasAttribute('hidden')) return;
        if (e.key === 'Escape') self.closeLightbox();
        else if (e.key === 'ArrowRight') { e.preventDefault(); self.lbStep(1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); self.lbStep(-1); }
        else if (e.key === 'Tab') self.lbTrapTab(e);
      });
      var raf = 0;
      lb.track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = 0; self.lbSyncDots(); });
      });
      return lb;
    }

    openLightbox(i, opener) {
      var cell = this.cells[i]; if (!cell || !cell.handle) return;
      var self = this, lb = this.ensureLightbox();
      this._lbOpener = opener || null;
      this._lbPrevFocus = document.activeElement;
      lb.cap.textContent = cell.color || '';
      lb.link.href = this.shopRoot() + 'products/' + cell.handle;
      // navigation signal: shopper leaves the picker for this colour's PDP via the
      // lightbox link. onclick (re-set per open) avoids stacking listeners.
      lb.link.onclick = function () {
        pushDL('pack_navigate', { pack_handle: self.pack, source: 'lightbox_link',
          destination: lb.link.href, color: cell.color });
      };
      // loading state: show the cut-out faded + a spinner while photos load
      lb.track.innerHTML = '<div class="bbb__lb-slide bbb__lb-loading"><img src="' + (cell.cutout || '') +
                           '" alt=""><span class="bbb__lb-spin" aria-hidden="true"></span></div>';
      lb.dots.innerHTML = '';
      lb.prev.style.display = 'none'; lb.next.style.display = 'none';
      this._lbCount = 0; this._lbIdx = 0;
      lb.el.removeAttribute('hidden');
      this.lbSize();   // pre-size to the last known photo ratio (all photos share it) to avoid a flash
      document.documentElement.classList.add('bbb-lb-open');
      lb.dialog.focus();
      pushDL('pack_sock_photos_open', { pack_handle: this.pack, color: cell.color });
      this.fetchProductImages(cell.handle).then(function (imgs) {
        if (lb.el.hasAttribute('hidden')) return;          // user closed it while loading
        self.lbRender(imgs, cell);
      }).catch(function () { self.lbRender([], cell); });
    }

    lbRender(imgs, cell) {
      var lb = this._lb;
      if (!imgs || !imgs.length) imgs = [{ src: cell.cutout || '', alt: cell.color || '' }];
      lb.track.innerHTML = imgs.map(function (im, k) {
        var alt = (im.alt || cell.color || '').replace(/"/g, '&quot;');
        return '<div class="bbb__lb-slide"><img src="' + im.src + '" alt="' + alt +
               '" loading="' + (k === 0 ? 'eager' : 'lazy') + '" decoding="async" draggable="false"></div>';
      }).join('');
      var multi = imgs.length > 1;
      lb.dots.innerHTML = multi ? imgs.map(function (im, k) {
        return '<button type="button" class="bbb__lb-dot' + (k === 0 ? ' is-on' : '') +
               '" data-k="' + k + '" aria-label="Photo ' + (k + 1) + '"></button>';
      }).join('') : '';
      lb.prev.style.display = multi ? '' : 'none';
      lb.next.style.display = multi ? '' : 'none';
      lb.track.scrollLeft = 0;
      this._lbCount = imgs.length;
      this._lbIdx = 0;
      // size the popup to the photos' aspect ratio so there's no empty space on
      // the sides (the photos share one ratio). Falls back to the CSS box if the
      // ratio is unknown (images[] endpoint without dimensions / fetch failure).
      var known = imgs.filter(function (im) { return im.ar && isFinite(im.ar) && im.ar > 0; });
      this._lbAR = known.length ? known[0].ar : 0;
      this.lbSize();
    }

    // Match the dialog to the photo aspect ratio, bounded by the viewport, so a
    // contain-fit photo fills it edge-to-edge (no letterbox bars). Recomputed on
    // open/render and on resize. Clears inline sizing when the ratio is unknown.
    lbSize() {
      var lb = this._lb; if (!lb) return;
      var ar = this._lbAR;
      if (!ar) { lb.dialog.style.width = ''; lb.track.style.width = ''; lb.track.style.height = ''; return; }
      var maxW = Math.min(560, window.innerWidth - 24);
      var maxH = Math.max(160, window.innerHeight - 96);   // leave room for the footer + margins
      var w = maxW, h = w / ar;
      if (h > maxH) { h = maxH; w = h * ar; }
      lb.dialog.style.width = Math.round(w) + 'px';
      lb.track.style.width = '100%';
      lb.track.style.height = Math.round(h) + 'px';
    }

    lbSyncDots() {
      var lb = this._lb; if (!lb || !this._lbCount) return;
      var w = lb.track.clientWidth || 1;
      var idx = Math.round(lb.track.scrollLeft / w);
      if (idx === this._lbIdx) return;
      this._lbIdx = idx;
      Array.prototype.forEach.call(lb.dots.children, function (d, k) { d.classList.toggle('is-on', k === idx); });
    }

    lbGoTo(k) {
      var lb = this._lb; if (!lb) return;
      lb.track.scrollTo({ left: k * lb.track.clientWidth, behavior: 'smooth' });
    }

    lbStep(d) {
      if (!this._lbCount) return;
      this.lbGoTo(Math.min(this._lbCount - 1, Math.max(0, (this._lbIdx || 0) + d)));
    }

    lbTrapTab(e) {
      var lb = this._lb; if (!lb) return;
      var f = Array.prototype.filter.call(
        lb.el.querySelectorAll('button, a[href], [tabindex="0"]'),
        function (x) { return x.offsetParent !== null && x.style.display !== 'none'; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    closeLightbox() {
      var lb = this._lb; if (!lb || lb.el.hasAttribute('hidden')) return;
      lb.el.setAttribute('hidden', '');
      document.documentElement.classList.remove('bbb-lb-open');
      var back = this._lbOpener || this._lbPrevFocus;
      if (back && back.focus) back.focus();
    }
  }
  if (!customElements.get('bulg-bundle-builder')) customElements.define('bulg-bundle-builder', BulgBundleBuilder);
})();
